export default __webpack_public_path__ + "static/media/icono-deducible.dc9e2b74.svg";